/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


/**
 * **Required Permission(s):** ORG_FSM_CONNECTION_LIST
 */
export const listFsmConnectionsResponseItem = zod.object({
  "id": zod.string().uuid(),
  "platform": zod.enum(['ColdStandard', 'HousecallPro', 'PoolBrain', 'ServiceTitan', 'Skimmer']),
  "isConnected": zod.boolean(),
  "isSyncEnabled": zod.boolean(),
  "lastCompletedWorkSyncAt": zod.string().datetime({}).nullish(),
  "lastTechSyncAt": zod.string().datetime({}).nullish(),
  "createdDate": zod.string().datetime({}),
  "payoutTriggers": zod.array(zod.object({
  "workType": zod.enum(['Invoice', 'RouteStop', 'WorkOrder', 'Visit', 'Reimbursement']),
  "category": zod.string().nullish()
})),
  "autoInviteUnmappedTechs": zod.boolean(),
  "isCompletedWorkPreApproved": zod.boolean(),
  "isAutoApprovalEnabled": zod.boolean()
})
export const listFsmConnectionsResponse = zod.array(listFsmConnectionsResponseItem)

/**
 * **Required Permission(s):** ORG_FSM_CONNECTION_GET
 */
export const getFsmConnectionByIdParams = zod.object({
  "id": zod.string().uuid()
})

export const getFsmConnectionByIdResponse = zod.object({
  "id": zod.string().uuid(),
  "platform": zod.enum(['ColdStandard', 'HousecallPro', 'PoolBrain', 'ServiceTitan', 'Skimmer']),
  "isConnected": zod.boolean(),
  "isSyncEnabled": zod.boolean(),
  "lastCompletedWorkSyncAt": zod.string().datetime({}).nullish(),
  "lastTechSyncAt": zod.string().datetime({}).nullish(),
  "createdDate": zod.string().datetime({}),
  "payoutTriggers": zod.array(zod.object({
  "workType": zod.enum(['Invoice', 'RouteStop', 'WorkOrder', 'Visit', 'Reimbursement']),
  "category": zod.string().nullish()
})),
  "autoInviteUnmappedTechs": zod.boolean(),
  "isCompletedWorkPreApproved": zod.boolean(),
  "isAutoApprovalEnabled": zod.boolean()
})

/**
 * **Required Permission(s):** ORG_FSM_CONNECTION_DISCONNECT
 */
export const disconnectFsmConnectionParams = zod.object({
  "id": zod.string().uuid()
})

/**
 * **Required Permission(s):** ORG_FSM_CONNECTION_GET
 */
export const getFsmConnectionSetupParams = zod.object({
  "id": zod.string().uuid()
})

export const getFsmConnectionSetupResponse = zod.object({
  "isConnected": zod.boolean(),
  "hasPayableTech": zod.boolean(),
  "hasPayoutTriggers": zod.boolean(),
  "isSyncEnabled": zod.boolean()
})

/**
 * **Required Permission(s):** ORG_FSM_CONNECTION_GET
 */
export const getFsmConnectionAvailablePayoutTriggersParams = zod.object({
  "id": zod.string().uuid()
})

export const getFsmConnectionAvailablePayoutTriggersResponseItem = zod.object({
  "workType": zod.enum(['Invoice', 'RouteStop', 'WorkOrder', 'Visit', 'Reimbursement']),
  "category": zod.string().nullish()
})
export const getFsmConnectionAvailablePayoutTriggersResponse = zod.array(getFsmConnectionAvailablePayoutTriggersResponseItem)

/**
 * **Required Permission(s):** ORG_FSM_CONNECTION_UPDATE
 */
export const updateFsmConnectionPayoutTriggersParams = zod.object({
  "id": zod.string().uuid()
})

export const updateFsmConnectionPayoutTriggersBody = zod.object({
  "payoutTriggers": zod.array(zod.object({
  "workType": zod.enum(['Invoice', 'RouteStop', 'WorkOrder', 'Visit', 'Reimbursement']),
  "category": zod.string().nullish()
}))
})

export const updateFsmConnectionPayoutTriggersResponse = zod.object({
  "id": zod.string().uuid(),
  "platform": zod.enum(['ColdStandard', 'HousecallPro', 'PoolBrain', 'ServiceTitan', 'Skimmer']),
  "isConnected": zod.boolean(),
  "isSyncEnabled": zod.boolean(),
  "lastCompletedWorkSyncAt": zod.string().datetime({}).nullish(),
  "lastTechSyncAt": zod.string().datetime({}).nullish(),
  "createdDate": zod.string().datetime({}),
  "payoutTriggers": zod.array(zod.object({
  "workType": zod.enum(['Invoice', 'RouteStop', 'WorkOrder', 'Visit', 'Reimbursement']),
  "category": zod.string().nullish()
})),
  "autoInviteUnmappedTechs": zod.boolean(),
  "isCompletedWorkPreApproved": zod.boolean(),
  "isAutoApprovalEnabled": zod.boolean()
})

/**
 * **Required Permission(s):** ORG_FSM_CONNECTION_UPDATE
 */
export const clearFsmConnectionCacheParams = zod.object({
  "id": zod.string().uuid()
})

/**
 * **Required Permission(s):** ORG_FSM_CONNECTION_UPDATE
 */
export const startFsmConnectionCompletedWorkPreviewParams = zod.object({
  "id": zod.string().uuid()
})

export const startFsmConnectionCompletedWorkPreviewBody = zod.object({
  "syncWindow": zod.string().nullish()
})

/**
 * **Required Permission(s):** ORG_FSM_CONNECTION_SET_MODE
 */
export const startFsmConnectionCompletedWorkSyncParams = zod.object({
  "id": zod.string().uuid()
})

export const startFsmConnectionCompletedWorkSyncBody = zod.object({
  "syncWindow": zod.string().nullish()
})

/**
 * **Required Permission(s):** ORG_FSM_CONNECTION_UPDATE
 */
export const startFsmConnectionTechSyncParams = zod.object({
  "id": zod.string().uuid()
})

/**
 * **Required Permission(s):** ORG_FSM_CONNECTION_GET
 */
export const getFsmConnectionSyncIssuesParams = zod.object({
  "id": zod.string().uuid()
})

export const getFsmConnectionSyncIssuesResponseItem = zod.object({
  "id": zod.string().uuid(),
  "externalType": zod.enum(['Invoice', 'RouteStop', 'WorkOrder', 'Visit', 'Reimbursement']),
  "externalId": zod.string(),
  "status": zod.enum(['Processed', 'AwaitingTechMapping', 'NotPayable', 'NotReady', 'Failed', 'Abandoned']),
  "completedAt": zod.string().datetime({}),
  "attemptCount": zod.number(),
  "nextAttemptAt": zod.string().datetime({}).nullish(),
  "failureReason": zod.string().nullish(),
  "customerName": zod.string().nullish()
})
export const getFsmConnectionSyncIssuesResponse = zod.array(getFsmConnectionSyncIssuesResponseItem)

/**
 * **Required Permission(s):** ORG_FSM_CONNECTION_UPDATE
 */
export const retryFsmCompletedWorkParams = zod.object({
  "fsmCompletedWorkId": zod.string().uuid()
})

export const retryFsmCompletedWorkResponse = zod.object({
  "id": zod.string().uuid(),
  "externalType": zod.enum(['Invoice', 'RouteStop', 'WorkOrder', 'Visit', 'Reimbursement']),
  "externalId": zod.string(),
  "status": zod.enum(['Processed', 'AwaitingTechMapping', 'NotPayable', 'NotReady', 'Failed', 'Abandoned']),
  "completedAt": zod.string().datetime({}),
  "attemptCount": zod.number(),
  "nextAttemptAt": zod.string().datetime({}).nullish(),
  "failureReason": zod.string().nullish(),
  "customerName": zod.string().nullish()
})

/**
 * **Required Permission(s):** ORG_FSM_CONNECTION_SET_MODE
 */
export const enableFsmConnectionSyncParams = zod.object({
  "id": zod.string().uuid()
})

export const enableFsmConnectionSyncResponse = zod.object({
  "id": zod.string().uuid(),
  "platform": zod.enum(['ColdStandard', 'HousecallPro', 'PoolBrain', 'ServiceTitan', 'Skimmer']),
  "isConnected": zod.boolean(),
  "isSyncEnabled": zod.boolean(),
  "lastCompletedWorkSyncAt": zod.string().datetime({}).nullish(),
  "lastTechSyncAt": zod.string().datetime({}).nullish(),
  "createdDate": zod.string().datetime({}),
  "payoutTriggers": zod.array(zod.object({
  "workType": zod.enum(['Invoice', 'RouteStop', 'WorkOrder', 'Visit', 'Reimbursement']),
  "category": zod.string().nullish()
})),
  "autoInviteUnmappedTechs": zod.boolean(),
  "isCompletedWorkPreApproved": zod.boolean(),
  "isAutoApprovalEnabled": zod.boolean()
})

/**
 * **Required Permission(s):** ORG_FSM_CONNECTION_SET_MODE
 */
export const disableFsmConnectionSyncParams = zod.object({
  "id": zod.string().uuid()
})

export const disableFsmConnectionSyncResponse = zod.object({
  "id": zod.string().uuid(),
  "platform": zod.enum(['ColdStandard', 'HousecallPro', 'PoolBrain', 'ServiceTitan', 'Skimmer']),
  "isConnected": zod.boolean(),
  "isSyncEnabled": zod.boolean(),
  "lastCompletedWorkSyncAt": zod.string().datetime({}).nullish(),
  "lastTechSyncAt": zod.string().datetime({}).nullish(),
  "createdDate": zod.string().datetime({}),
  "payoutTriggers": zod.array(zod.object({
  "workType": zod.enum(['Invoice', 'RouteStop', 'WorkOrder', 'Visit', 'Reimbursement']),
  "category": zod.string().nullish()
})),
  "autoInviteUnmappedTechs": zod.boolean(),
  "isCompletedWorkPreApproved": zod.boolean(),
  "isAutoApprovalEnabled": zod.boolean()
})

/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_APPROVE
 */
export const enableFsmConnectionAutoApprovalParams = zod.object({
  "id": zod.string().uuid()
})

export const enableFsmConnectionAutoApprovalResponse = zod.object({
  "id": zod.string().uuid(),
  "platform": zod.enum(['ColdStandard', 'HousecallPro', 'PoolBrain', 'ServiceTitan', 'Skimmer']),
  "isConnected": zod.boolean(),
  "isSyncEnabled": zod.boolean(),
  "lastCompletedWorkSyncAt": zod.string().datetime({}).nullish(),
  "lastTechSyncAt": zod.string().datetime({}).nullish(),
  "createdDate": zod.string().datetime({}),
  "payoutTriggers": zod.array(zod.object({
  "workType": zod.enum(['Invoice', 'RouteStop', 'WorkOrder', 'Visit', 'Reimbursement']),
  "category": zod.string().nullish()
})),
  "autoInviteUnmappedTechs": zod.boolean(),
  "isCompletedWorkPreApproved": zod.boolean(),
  "isAutoApprovalEnabled": zod.boolean()
})

/**
 * **Required Permission(s):** ORG_PAYOUT_REQUEST_APPROVE
 */
export const disableFsmConnectionAutoApprovalParams = zod.object({
  "id": zod.string().uuid()
})

export const disableFsmConnectionAutoApprovalResponse = zod.object({
  "id": zod.string().uuid(),
  "platform": zod.enum(['ColdStandard', 'HousecallPro', 'PoolBrain', 'ServiceTitan', 'Skimmer']),
  "isConnected": zod.boolean(),
  "isSyncEnabled": zod.boolean(),
  "lastCompletedWorkSyncAt": zod.string().datetime({}).nullish(),
  "lastTechSyncAt": zod.string().datetime({}).nullish(),
  "createdDate": zod.string().datetime({}),
  "payoutTriggers": zod.array(zod.object({
  "workType": zod.enum(['Invoice', 'RouteStop', 'WorkOrder', 'Visit', 'Reimbursement']),
  "category": zod.string().nullish()
})),
  "autoInviteUnmappedTechs": zod.boolean(),
  "isCompletedWorkPreApproved": zod.boolean(),
  "isAutoApprovalEnabled": zod.boolean()
})

/**
 * **Required Permission(s):** ORG_FSM_CONNECTION_UPDATE
 */
export const setFsmConnectionAutoInviteParams = zod.object({
  "id": zod.string().uuid()
})

export const setFsmConnectionAutoInviteBody = zod.object({
  "autoInviteUnmappedTechs": zod.boolean()
})

export const setFsmConnectionAutoInviteResponse = zod.object({
  "id": zod.string().uuid(),
  "platform": zod.enum(['ColdStandard', 'HousecallPro', 'PoolBrain', 'ServiceTitan', 'Skimmer']),
  "isConnected": zod.boolean(),
  "isSyncEnabled": zod.boolean(),
  "lastCompletedWorkSyncAt": zod.string().datetime({}).nullish(),
  "lastTechSyncAt": zod.string().datetime({}).nullish(),
  "createdDate": zod.string().datetime({}),
  "payoutTriggers": zod.array(zod.object({
  "workType": zod.enum(['Invoice', 'RouteStop', 'WorkOrder', 'Visit', 'Reimbursement']),
  "category": zod.string().nullish()
})),
  "autoInviteUnmappedTechs": zod.boolean(),
  "isCompletedWorkPreApproved": zod.boolean(),
  "isAutoApprovalEnabled": zod.boolean()
})

/**
 * **Required Permission(s):** ORG_FSM_CONNECTION_TEST
 */
export const testFsmConnectionParams = zod.object({
  "id": zod.string().uuid()
})

export const testFsmConnectionResponse = zod.object({
  "isSuccess": zod.boolean(),
  "isTerminalFailure": zod.boolean(),
  "failureKind": zod.enum(['Invalid', 'Unauthorized', 'Forbidden', 'NotFound', 'Conflict', 'RateLimited']).optional(),
  "errorCode": zod.string().nullish(),
  "errorMessage": zod.string().nullish(),
  "errorData": zod.record(zod.string(), zod.unknown()).nullish(),
  "retryAfter": zod.string().nullish()
})

